import { getOptions as getOptionRouterBase } from '../../../router/definitionGloblaRoutes';
import { getData as getDataCommunication } from '../../../pages/main/comunications/CommunicationsLayout/routes';
import { getData as getDataWorkOrders } from '../../../pages/main/workOrders/WorkOrdersLayout/routes';
import { getData as getDataSurveillanceRoute } from '../../../pages/main/surveillanceRoute/SurveillanceRouteLayout/routes';
import { getData as getDataReporting } from '../../../pages/main/reporting/ReportingLayout/routes';
import { getData as getDataManagement } from '../../../pages/main/management/managementRouteLayout/routes';
import { getData as getDataAdmin } from '../../../pages/main/admin/adminRouteLayout/routes';
import { optionsTypes } from './types';

// Map from route value → sub-route data provider.
// Dashboard has no sub-routes (single page), so it's not listed here.
// Nota (main PR #61): Budgets dejó de ser sección propia — su único contenido
// (el histórico) vive ahora dentro de Reporting. Por eso NO aparece en este map.
const SUB_ROUTE_PROVIDERS: Record<string, (t: (key: string) => string) => any[]> = {
  communication: getDataCommunication,
  'work-orders': getDataWorkOrders,
  'surveillance-route': getDataSurveillanceRoute,
  reporting: getDataReporting,
  management: getDataManagement,
  admin: getDataAdmin,
};

export const getOptions = (t: (key: string) => string): optionsTypes[] => {
  const options: optionsTypes[] = [...getOptionRouterBase(t)];

  return options.map((option) => {
    const provider = SUB_ROUTE_PROVIDERS[option.value];
    if (provider) {
      return { ...option, data: [...provider(t)] };
    }
    return option;
  });
};

// Para compatibilidad con imports existentes
import { options as OptionRouterBase } from '../../../router/definitionGloblaRoutes';
export const options: optionsTypes[] = [...OptionRouterBase];
